const test = () => import ('@/pages/test/test')
export default [
    {
        path: 'test/test',
        name:'test/test',
        component: test
    }
]


// WEBPACK FOOTER //
// ./src/router/test.js